import React, { Component } from 'react'

import Button from './Button'
import Link from './Link'

import { createCookie, readCookie } from '../../utils/cookies'
import { doNotTrackEnabled, enableTracking } from '../../utils/tracking'

import { IS_DEV, COOKIES_TRACKING_CONSENT_COOKIE_NAME } from '../../config'

class CookiesAndAnalyticsInfo extends Component {
  constructor (props) {
    super(props)
    this.state = {
      loading: true,
      hasStoredCookie: false,
      cookies: true,
      analytics: true
    }
    this.handleCloseMessage = this.handleCloseMessage.bind(this)
    this.handleAcceptAnalytics = this.handleAcceptAnalytics.bind(this)
    this.handleRefuseAnalytics = this.handleRefuseAnalytics.bind(this)
  }
  componentDidMount () {
    const storedCookie = readCookie(COOKIES_TRACKING_CONSENT_COOKIE_NAME)
    let update = {
      loading: false,
      hasStoredCookie: !!storedCookie
    }
    if (!storedCookie && doNotTrackEnabled()) {
      update.analytics = false
    }
    this.setState(update)
  }
  handleAcceptAnalytics () {
    this.setState({ analytics: true }, this.handleCloseMessage)
  }
  handleRefuseAnalytics () {
    this.setState({ analytics: false }, this.handleCloseMessage)
  }
  handleCloseMessage () {
    const { analytics } = this.state
    createCookie(
      COOKIES_TRACKING_CONSENT_COOKIE_NAME,
      JSON.stringify({
        cookie: true,
        analytics
      }),
      1000,
      !IS_DEV && '.snips.ai' // share across snips domains
    )
    if (analytics) {
      enableTracking()
    }
    this.setState({ hasStoredCookie: true })
  }
  render () {
    const { loading, hasStoredCookie } = this.state
    if (loading || hasStoredCookie) {
      return null
    }
    return (
      <div className='cookies-analytics-info'>
        <div className='col-11 md-col-9 maxw-large mx-auto md-flex justify-between items-center p1'>
          <div className='cookies-analytics-info__text mr1 mx2'>
            We'd like to use cookies and collect analytics to improve Snips'
            websites.<br />
            You can find out more in our&nbsp;
            <Link
              href='http://privacy.snips.ai/'
              target='_blank'
              className='link--plain link--underlined'
            >
              Privacy Policy
            </Link>.
          </div>
          <div className='inline-flex'>
            <Button
              className='button button--thin button--outline cookies-analytics-info__button mr2'
              type='submit'
              onClick={this.handleRefuseAnalytics}
            >
              Decline
            </Button>
            <Button
              className='button button--thin button--primary cookies-analytics-info__button'
              type='submit'
              onClick={this.handleAcceptAnalytics}
            >
              Accept
            </Button>
          </div>
        </div>
      </div>
    )
  }
}

export default CookiesAndAnalyticsInfo



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/CookiesAndAnalyticsInfo.js